import React from "react";
import { Trash2 } from "lucide-react";

export const EntriesTable = ({ items, remove }) => (
  <section className="px-6 sm:px-12 lg:px-20 pb-24 max-w-6xl mx-auto">
    <p className="label-eyebrow mb-4">All entries</p>
    <div className="bg-[#F1ECE4] border border-[#D1C7B8] rounded-3xl overflow-hidden">
      {items.length === 0 ? (
        <p className="p-6 text-[#5C6359]" data-testid="no-entries">No entries yet.</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="bg-[#EAE3D9] text-[#5C6359] uppercase tracking-widest text-xs">
            <tr>
              <th className="text-left p-4">Date</th>
              <th className="text-left p-4">Marker</th>
              <th className="text-left p-4">Value</th>
              <th className="text-left p-4">Notes</th>
              <th className="p-4"></th>
            </tr>
          </thead>
          <tbody>
            {items.map((b) => (
              <tr key={b.id} className="border-t border-[#D1C7B8]" data-testid={`bio-row-${b.id}`}>
                <td className="p-4 text-[#2D322B]">{new Date(b.date).toLocaleDateString()}</td>
                <td className="p-4 text-[#2D322B] font-serif">{b.marker}</td>
                <td className="p-4 text-[#C05C42]">{b.value} {b.unit}</td>
                <td className="p-4 text-[#5C6359]">{b.notes || "—"}</td>
                <td className="p-4 text-right">
                  <button onClick={() => remove(b.id)} className="text-[#8F3A3A] hover:text-[#C05C42]" data-testid={`delete-bio-${b.id}`}>
                    <Trash2 className="w-4 h-4" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  </section>
);
